//------------------------------------------------------------------------------
// 住所検索
//------------------------------------------------------------------------------
import backend from '@/common/backend';

/**
 * 市区町村検索
 *
 * @param {string} code 都道府県コード(2桁)
 * @return {Promise<object[]>} 市区町村一覧
 *       - value 市区町村コード(11桁)
 *       - label 市区町村名
 */
export async function municipalities(code) {
  if (!code || code.length < 2) {
    return [];
  }
  const api = '/master/address/' + code.substring(0, 2);
  const res = await backend.get(api);
  return res.parseBodyAsArray();
}

/**
 * 大字通称検索
 *
 * @param {string} code 市区町村コード(11桁)
 * @return {Promise<object[]>} 大字通称一覧
 *       - value 大字通称コード(11桁)
 *       - label 大字通称ラベル
 */
export async function oazatusyo(code) {
  if (!code || code.length < 5) {
    return [];
  }
  const api = '/master/address/' + code.substring(0, 5);
  const res = await backend.get(api);
  return res.parseBodyAsArray();
}

/**
 * 字丁目検索
 *
 * @param {string} code 大字通称コード(11桁)
 * @return {Promise<object[]>} 字丁目一覧
 *       - value 字丁目コード(11桁)
 *       - label 字丁目ラベル
 */
export async function azatyome(code) {
  if (!code || code.length < 8) {
    return [];
  }
  const api = '/master/address/' + code.substring(0, 8);
  const res = await backend.get(api);
  return res.parseBodyAsArray();
}

// デフォルトエクスポート
export default {
  municipalities,
  oazatusyo,
  azatyome,
};
